<template>
  <div
    class="base-select-wrapper"
    :class="{
      contactForm: context.isContactForm,
    }"
  >
    <v-select
      v-model="selected"
      class="custom-select"
      :clearable="context.attrs.clearable"
      :filterable="context.attrs.filterable"
      :searchable="context.attrs.searchable"
      :options="options"
      :class="context.classes.select"
      :placeholder="context.attrs.placeholder"
      :get-option-key="getOptionKey"
      :get-option-label="getOptionKey"
      :disabled="context.disabled"
    >
      <template #option="option">
        <div class="selected d-center flex items-center justify-between">
          <span>{{ optionNameKey ? option[optionNameKey] : option.label }}</span>
          <figure class="selected-icon overflow-hidden">
            <img loading="lazy" src="/img/contacts-page/selected-role.png" class="object-contain" />
          </figure>
        </div>
      </template>
      <template #selected-option="option">
        <div class="selected d-center truncate">
          <span class="truncate">{{ optionNameKey ? option[optionNameKey] : option.label }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
// eslint-disable-next-line no-restricted-syntax
export default {
  name: "BaseSelect",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },

  computed: {
    optionNameKey() {
      return this.context.optionNameKey
    },
    options() {
      return this.context.options
    },
    selected: {
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.context._value
      },

      set(newValue) {
        this.context.node.input(newValue)
      },
    },
  },
  methods: {
    getOptionKey(option) {
      if (this.optionNameKey) {
        return option[this.optionNameKey]
      }
      if (typeof option === "object" && option.id) {
        return option.id
      }
      try {
        return JSON.stringify(option)
      } catch (e) {
        return console.warn("[vue-select warn]: Could not stringify option ")
      }
    },
  },
}
</script>

<style lang="scss">
:root {
  --vs-dropdown-box-shadow: none;
  --vs-dropdown-option--active-bg: transparent;
  --vs-dropdown-option--active-color: #43784e;
  --vs-disabled-bg: inherit;
}

.base-select-wrapper {
  .vs__dropdown-toggle {
    @apply w-full h-full px-2 py-[10px] bg-background border-background rounded-lg text-base font-normal placeholder-gray outline outline-1 outline-transparent text-inherit;
    font-weight: inherit;
    .vs__selected-options {
      @apply truncate items-center;
    }
    .vs__selected {
      @apply truncate;
    }
  }

  .vs__search::placeholder {
    @apply text-gray;
  }

  .vs__clear,
  .vs__open-indicator {
    @apply fill-primary;
  }

  .vs__dropdown-toggle {
    position: relative;
    &::after {
      content: '⌵';
      position: absolute;
      right: 12px;
      bottom: -0px;
      transform: translateY(-50%);
      font-size: 20px;
      color: #43784e;
      pointer-events: none;
    }
  }

  .vs--open .vs__dropdown-toggle::after {
    content: none;
  }

  .vs--open {
    .vs__dropdown-toggle {
      @apply rounded-lg;
    }
  }

  .vs__dropdown-menu {
    @apply mt-2 px-4 pt-2 rounded-lg border border-solid border-primary bg-background;
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar {
      width: 27px;
      height: 0;
    }
    &::-webkit-scrollbar-track {
      @apply bg-gray-light rounded-[16px];
    }
    &::-webkit-scrollbar-thumb {
      height: 10px;
      border: 11px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      -webkit-border-radius: 10px;
      -webkit-box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.025);
      @apply bg-primary rounded-[16px];
    }
    &::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    .vs__dropdown-option {
      @apply border-b px-0 py-2 border-gray-light;
      &--highlight {
        background: none;
        @apply text-primary-hover;
      }
      & figure {
        display: none;
      }
      &--selected {
        @apply text-primary-pressed;
      }
    }
  }
  &.contactForm {
    .vs__dropdown-option {
      @apply text-black border-b px-2 py-2 border-[#EEEEEE] last:border-0 hover:text-primary active:text-primary active:bg-inherit;
      div {
        @apply pt-[2px] text-[18px];
      }
      &--highlight {
        background: none;
      }
      & figure {
        display: none;
      }
      &--selected {
        & figure {
          display: block;
        }
      }
    }
    .vs__dropdown-menu {
      @apply border-[1px] border-primary py-[10xp] pr-0 bg-gray-light;
      &::-webkit-scrollbar {
        display: block;
      }
    }
    .vs--open {
      .vs__dropdown-toggle {
        @apply border-primary;
      }
    }
    .vs__dropdown-toggle {
      @apply md:bg-gray-light bg-white rounded-[0.625rem] border-[1px];
    }
  }

  .vs__selected {
    position: static !important;
    color: inherit !important;
    font-weight: inherit !important;
    margin-top: 0;
  }
}

.white-input {
  .base-select-wrapper {
    .vs__dropdown-toggle {
      background-color: white;
    }
  }
}

.hide-actions {
  .base-select-wrapper {
    .vs__actions {
      padding-top: 0;
    }

    .vs__search {
      position: absolute;
    }

    .vs__dropdown-toggle {
      padding: 0;

      .vs__selected {
        padding: 0;
        margin: 0;
      }
    }
  }
}

.max-content {
  .base-select-wrapper {
    .vs__dropdown-menu {
      width: 100%;
      min-width: max-content;
      left: auto;
      right: 0;
    }
  }
}
</style>
